export default __webpack_public_path__ + "static/media/EDIT_BLACK.34c3ad43.svg";